export const TEMPLATE_ACCESS = 'TEMPLATE_ACCESS';
export const SUBMISSION_ACCESS = 'SUBMISSION_ACCESS';

export interface AccessEntry {
  AccessorId: string;
  role?: string;
  permission?: string;
  isEveryone?: boolean;
  groupId: string;
  canEdit?: boolean;
}

export const TEMPLATE_PERMISSIONS = [
  {
    label: 'Can only submit',
    description: 'User can only submit the template.',
    value: 'submitter',
  },
  {
    label: 'Can edit template',
    description: 'User can submit the template and edit its contents.',
    value: 'admin',
  },
];

export const SUBMISSION_PERMISSIONS = [
  {
    label: 'Can view my own submissions',
    description: 'See the submissions completed by you only.',
    value: 'CAN_VIEW_OWN_SUBMISSIONS',
  },
  {
    label: 'Can view my own and my locations',
    description: 'View your submissions and those from authorized locations.',
    value: 'CAN_VIEW_OWN_AND_LOCATION_SUBMISSIONS',
  },
  {
    label: 'Can view all submissions across all locations',
    description: 'View all submissions across all locations.',
    value: 'CAN_VIEW_ALL_SUBMISSIONS',
  },
  {
    label: 'Can edit',
    description: 'Edit submissions you have permission to view.',
    value: 'CAN_EDIT_OWN_SUBMISSIONS',
  },
];
